export function formatCurrency(amount: number, currency: 'usd' | 'inr' = 'usd') {
  switch (currency.toLowerCase()) {
    case 'inr':
      return `₹${amount / 100}`;
    default:
      return `$${amount / 100}`;
  }
}
